module.exports = __webpack_public_path__ + "img/ES-CT.93c64661.svg";